import * as React from 'react';
import SimpleLayout from '../SimpleLayout/SimpleLayout';
import { CircularProgress } from '@material-ui/core';

export interface LoadingScreenProps {}

const LoadingScreen: React.FC<LoadingScreenProps> = ({}) => {
  return (
    <SimpleLayout>
      <CircularProgress />
    </SimpleLayout>
  );
};

export default LoadingScreen;
